
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestmoversnearby/privacy-policy",
      function () {
        return require("private-next-pages/bestmoversnearby/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestmoversnearby/privacy-policy"])
      });
    }
  